module.exports = __webpack_public_path__ + "static/media/fa-solid-900.132e9759.ttf";